import type { Reducer, Store } from 'redux';
import type { Epic } from 'redux-observable';
import initiateStore from '@atlassian/jira-common-tangerine/src/state/initiate.tsx';
import type { Action } from './actions/index.tsx';
import rootReducer from './reducer/index.tsx';
import type { State } from './reducer/types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { Action, State };

const createStore = <TState, TAction>(rootEpic?: Epic<TAction, TState>): Store<TState> => {
	// @ts-expect-error - TS2322 - Type 'Reducer<unknown>' is not assignable to type 'Reducer<TState>'.
	const fixedTypeRootReducer: Reducer<TState> = rootReducer;

	// @ts-expect-error - TS2344 - Type 'TAction' does not satisfy the constraint '{ type: any; }'.
	return initiateStore<TState, TAction, undefined>({
		appName: 'directory-base',
		rootReducer: fixedTypeRootReducer,
		rootEpic,
	});
};

export default createStore;
